<template>
	<div class="center">
		<div class="status-bar"></div>
		<div class="btns">
			<!--<img src="@/assets/images/center/scan.png" alt="" class="btn" />-->
			<img @click="toSetting" src="@/assets/images/center/setting.png" alt="" class="btn" />
		</div>
		<div class="user-info">
			<img src="@/assets/images/center/avatar.png" alt="" class="avatar" />
			<div>
				<div class="username">
					<div>{{ userStore.userInfo.F_RealName }}</div>
					<!--<img class="select" src="@/assets/images/center/select.png" alt="" />-->
				</div>
				<div class="account">
					账号：{{ userStore.userInfo.F_Account || userStore.userInfo.F_UserId }}
				</div>
			</div>
		</div>
		<div class="cell-group-wrap">
			<div class="cell-group">
				<div
					class="cell"
					:class="{ border: item.border }"
					v-for="(item, index) in list"
					:key="index"
					@click="onClick(item.id)"
				>
					<img :src="item.icon" alt="" class="icon" />
					<div class="title">{{ item.title }}</div>
					<div class="tip">{{ item.tip }}</div>
					<img src="@/assets/images/center/arrow.png" alt="" class="arrow" />
				</div>
			</div>
		</div>
		<div class="version">{{ appVersion }}</div>
		<account-list ref="accountListRef" />
		<!--		<img class="banner" src="@/assets/images/center/banner.png" alt="" />-->
	</div>
</template>

<script setup lang="ts">
import phoneIcon from '@/assets/images/center/phone.png'
import emailIcon from '@/assets/images/center/email.png'
import passwordIcon from '@/assets/images/center/password.png'
import safeIcon from '@/assets/images/center/safe.png'
import linkIcon from '@/assets/images/center/link.png'
import thirdLoginIcon from '@/assets/images/center/third_login.png'
import biometricsIcon from '@/assets/images/center/biometrics.png'
import preferenceIcon from '@/assets/images/center/preference.png'
import languageIcon from '@/assets/images/center/language.png'
import updateIcon from '@/assets/images/center/update.png'
import aboutIcon from '@/assets/images/center/about.png'
import clearIcon from '@/assets/images/center/clear.png'
import AccountList from './components/AccountList.vue'
import { useAuthStore } from '@/store/auth'
import { Dialog, Toast } from 'vant'
import getNativeInstance from '@/utils/JSBridge'
import { openWebview } from '@/utils'

const router = useRouter()
const appVersion = ref('v1.0.0')

const accountListRef = ref<any>(null)

const userStore = useAuthStore()
console.log(userStore.userInfo)

const showAccount = () => {
	console.log(accountListRef.value)
	accountListRef.value.show = true
}

const list = ref<
	Array<{ icon: string; title: string; border?: boolean; id: number; path?: string; tip?: string }>
>([
	{
		id: 1,
		icon: phoneIcon,
		title: '个人信息'
	},
	{
		id: 2,
		icon: emailIcon,
		title: '查看消息'
	},
	{
		id: 3,
		icon: passwordIcon,
		title: '帮助指南'
	},
	// {
	// 	id: 4,
	// 	icon: safeIcon,
	// 	title: '安全问题'
	// },
	// {
	// 	id: 5,
	// 	icon: linkIcon,
	// 	title: '关联账号'
	// },
	// {
	// 	id: 6,
	// 	icon: thirdLoginIcon,
	// 	title: '第三方登录'
	// },
	// {
	// 	id: 7,
	// 	icon: biometricsIcon,
	// 	title: '生物识别',
	// 	border: true
	// },
	// {
	// 	id: 8,
	// 	icon: preferenceIcon,
	// 	title: '偏好设置'
	// },
	// {
	// 	id: 9,
	// 	icon: languageIcon,
	// 	title: '语言设置'
	// },
	// {
	// 	id: 10,
	// 	icon: updateIcon,
	// 	title: '版本更新'
	// },
	{
		id: 12,
		icon: clearIcon,
		title: '清理缓存',
		tip: '0M'
	},
	{
		id: 13,
		icon: updateIcon,
		title: '版本升级'
	},
	{
		id: 11,
		icon: aboutIcon,
		title: '关于我们',
		path: '/layout/aboutUs'
	},
	{
		id: 99,
		icon: aboutIcon,
		title: '测试'
	}
])

const onClean = () => {
	Toast('清理缓存成功')
}

const onClick = (id: number) => {
	switch (id) {
		case 1:
			// router.push({
			// 	path: '/layout/application-page',
			// 	query: {
			// 		title: '个人信息',
			// 		link: 'http://authserver.xju.edu.cn/personalInfo/personalMobile/index.html'
			// 	}
			// })
			openWebview({
				url: 'http://authserver.xju.edu.cn/personalInfo/personalMobile/index.html',
				title: '个人信息'
			})
			break
		case 2:
			// router.push({
			// 	path: '/layout/application-page',
			// 	query: {
			// 		title: '查看消息',
			// 		link: 'http://ehall.xju.edu.cn/psfw/sys/swmxxtsapp/*default/index.do'
			// 	}
			// })
			openWebview({
				url: 'http://ehall.xju.edu.cn/psfw/sys/swmxxtsapp/*default/index.do',
				title: '查看消息'
			})
			// openWebview('http://ehall.xju.edu.cn/psfw/sys/swmxxtsapp/*default/index.do')
			// window.open('http://ehall.xju.edu.cn/psfw/sys/swmxxtsapp/*default/index.do')
			break
		case 3:
			// router.push({
			// 	path: '/layout/application-page',
			// 	query: {
			// 		title: '帮助指南',
			// 		link: 'http://ehall.xju.edu.cn/psfw/sys/swmtzggapp/*default/index.do'
			// 	}
			// })
			openWebview({
				url: 'http://ehall.xju.edu.cn/psfw/sys/swmtzggapp/*default/index.do',
				title: '帮助指南'
			})
			// window.open('http://ehall.xju.edu.cn/psfw/sys/swmtzggapp/*default/index.do')
			break
		case 11:
			router.push({ path: '/layout/aboutUs' })
			break
		case 12:
			onClean()
			break
		case 13:
			checkUpdate()
			break
		case 99:
			if (window.UniAppJSBridge) {
				getNativeInstance().customInvoke({
					action: 'loginByCas',
					data: {
						ticket: 'ticket00909090'
					}
				})
			}
			break
	}
}

const checkUpdate = () => {
	if (window.UniAppJSBridge) {
		getNativeInstance().customInvoke({
			action: 'checkAppUpdate',
			data: {
				type: 1
			}
		})
	}
}

const getVersion = () => {
	if (window.plus) {
		plus.runtime.getProperty(plus.runtime.appid, (info) => {
			appVersion.value = info.version
		})
	}
	// if (window.UniAppJSBridge) {
	// 	getNativeInstance()
	// 		.customInvoke({
	// 			action: 'getAppInfo'
	// 		})
	// 		.then((res) => {
	// 			appVersion.value = res.version
	// 		})
	// 		.catch((err) => {
	// 			console.log(err)
	// 		})
	// }
}

const toSetting = () => {
	router.push({
		path: '/page/setting'
	})
}

onMounted(() => {
	getVersion()
})
</script>

<style scoped lang="scss">
.center {
	//padding: 44px 20px 100px;
	background-image: url('@/assets/images/center/centerXQ.png');
	background-position: 0 44px;
	background-size: 375px 232px;
	background-repeat: no-repeat;
	position: relative;
	.status-bar {
		background-image: url('@/assets/images/center/centerTopBgXQ.png');
		background-size: 100% 44px;
		background-repeat: no-repeat;
		width: 100%;
		height: 44px;
	}
	.btns {
		position: absolute;
		top: 53px;
		right: 10px;
		.btn {
			width: 30px;
			margin-left: 15px;
		}
	}
	.user-info {
		padding: 58px 20px 0 20px;
		display: flex;
		align-items: center;
		.avatar {
			width: 76px;
			margin-right: 22px;
		}
		.username {
			display: flex;
			align-items: center;
			font-size: 20px;
			font-weight: 500;
			line-height: 23px;
			color: #ffffff;
			.select {
				margin-left: 10px;
				width: 22px;
			}
		}
		.account {
			margin-top: 10px;
			font-size: 14px;
			color: #ffffff;
			line-height: 16px;
		}
	}
	.version {
		color: #999;
		font-size: $smallFontSize;
		margin-top: 30px;
		text-align: center;
	}
	.cell-group-wrap {
		padding: 0 20px;
		box-sizing: border-box;
	}
	.cell-group {
		margin-top: 22px;
		background: #ffffff;
		border-radius: 10px;
		box-shadow: 0 1px 8px 0 rgba(85, 19, 13, 0.05);
		padding: 20px 15px 40px;
		.cell {
			display: flex;
			align-items: center;
			margin-bottom: 18px;
			.icon {
				width: 20px;
				margin-right: 10px;
			}
			.title {
				font-size: $commonFontSize;
				color: #424649;
				flex: 1;
			}
			.tip {
				font-size: 14px;
				color: #999;
				margin-right: 10px;
			}
			.arrow {
				width: 18px;
			}
		}
		.border {
			padding-bottom: 18px;
			border-bottom: 1px solid #f4f3f3;
		}
	}
}
</style>
